/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f47sw1k{padding-block:var(--spacingVerticalXS);}
.f9b8bpc{padding-block:var(--spacingVerticalS);}
.fjshy37{padding-inline:var(--spacingHorizontalL);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fy9rknc{font-size:var(--fontSizeBase200);}
.fwrc4pm{line-height:var(--lineHeightBase200);}
.fl43uef{font-weight:var(--fontWeightSemibold);}
.f11d4kpn{color:var(--colorNeutralForeground3);}
.f122n59{align-items:center;}
.f1xcgk68{column-gap:var(--spacingHorizontalM);}
.fsmx9qy{min-block-size:44px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1hcf779{margin-inline:var(--spacingHorizontalS);}
.f47sw1k{padding-block:var(--spacingVerticalXS);}
.f12n3xlw{padding-inline:var(--spacingHorizontalM);}
.ft85np5{border-radius:var(--borderRadiusMedium);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f19n0e5{color:var(--colorNeutralForeground1);}
.f1k6fduh{cursor:pointer;}
.f1bgiulx{background-color:var(--bfSelectedBackground);}
.fulqd5u{color:var(--bfSelectedForeground);}
.fi64zpg{flex-shrink:0;}
.f16muhyy{color:var(--colorBrandForeground1);}
.fqerorx{flex-grow:1;}
.fuzgk9b{min-inline-size:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1a3p1vp{overflow:hidden;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1cmbuwj{text-overflow:ellipsis;}
.fz5stix{white-space:nowrap;}
.f1fedwem{font-family:var(--fontFamilyMonospace);}
.fyind8e{color:var(--colorBrandForegroundLink);}
.f16xkysk{background-color:var(--colorBrandBackground2);}
.f1ym3bx4{color:inherit;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.fq9zq91{border-radius:var(--borderRadiusSmall);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1euv43f{position:absolute;}
.fittdk8{inline-size:1px;}
.f156r0dy{block-size:1px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1a3p1vp{overflow:hidden;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1wch0ki{clip-path:inset(50%);}
/** @griffel:css-end **/